module.exports = __webpack_public_path__ + "static/media/upload-cloud-black.40a33b14.svg";